// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  isLocal: false,
  isBasicAuth: true,
  BASE_URL: '',
  AUTH_CONFIG: {
    clientID: 'c025d805-c0d4-4f95-94c2-46788fad03fb',
    authority:
      'https://login.microsoftonline.com/36da45f1-dd2c-4d1f-af13-5abe46b99921',
    redirectUri: 'https://dev-oci-dfte.deloitte.com/',
    cacheLocation: 'sessionStorage',
    postLogoutRedirectUri: 'https://dev-oci-dfte.deloitte.com/',
    navigateToLoginRequestUrl: false,
    consentScopes: [],
    unprotectedResources: ['https://www.microsoft.com/en-us/'],
    logger: (logLevel: any, message: any, piiEnabled: any) => undefined,
    correlationId: '1234',
    piiLoggingEnabled: true,
  },
  AUTH_RESOURCE_LINK: {
    self: 'https://graph.microsoft.com/v1.0/me',
    users: 'https://graph.microsoft.com/v1.0/users',
    webAPI: '',
  },
  LOCAL_AUTH: {
    // userId: 'vintiwari@deloitte.com',
    // username: 'Vinay'
    // userId: 'hariprasad@deloitte.com',
    // username: 'Hari'
    // userId: 'rupole@deloitte.com',
    // username: 'Rutuja'
    // userId: 'lchalla@deloitte.com',
    // username: 'Lokesh'
    userId: 'yasiiqbal@deloitte.com',
    username: 'Yasir',
    // userId: 'nanaaz@deloitte.com',
    // username: 'Nadhiya'
  },
  LOCAL_USERS: [],
  blobStorage: {
    privacyjs:
      'https://azrguse2conoracleofferin.blob.core.windows.net/dfteprivacy-content/dev-privacy-popup.js?sp=r&st=2023-01-02T11:33:32Z&se=2024-12-31T18:29:32Z&spr=https&sv=2021-06-08&sr=c&sig=9MenpKCgcgpCxWeHKE49DMU6gsOEM4o%2BChVFbTEXHiw%3D',
    privayPDF:
      'https://azrguse2conoracleofferin.blob.core.windows.net/dfteprivacy-content/deloitte-privacy-content.pdf?sp=r&st=2022-04-06T05:40:22Z&se=2024-11-30T13:40:22Z&spr=https&sv=2020-08-04&sr=b&sig=Jsds8ZshGiQDLtTcUPHVVi6P2FExfca6I3oaxLpo%2FY4%3D',
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
